/* Plantilla «Alimentación» (secciones gl-ali-*): variantes, cantidad, galería, ampliar foto, pestañas, pasos,
   paginación de reseñas, menú del móvil, barra fija, recomendaciones y pie al final. Sin dependencias. */
(function () {
  if (window.__glaCargado) return;
  window.__glaCargado = true;

  function miles(n, sepMil, sepDec, dec) {
    var t = (n / 100).toFixed(dec), p = t.split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, sepMil);
    return dec ? p[0] + sepDec + p[1] : p[0];
  }
  function dinero(cent, formato) {
    cent = Math.round(Number(cent) || 0);
    var f = String(formato || '{{amount_with_comma_separator}} €').replace(/<[^>]*>/g, '');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return miles(cent, ',', '.', 0);
        case 'amount_with_comma_separator': return miles(cent, '.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return miles(cent, '.', ',', 0);
        case 'amount_with_apostrophe_separator': return miles(cent, "'", '.', 2);
        case 'amount_with_space_separator': return miles(cent, ' ', ',', 2);
        default: return miles(cent, ',', '.', 2);
      }
    });
  }
  function todos(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }

  // ------------------------------------------------------------ galería
  function galeria(root) {
    var g = root.querySelector('[data-gla-galeria]');
    if (!g) return null;
    var pista = g.querySelector('[data-gla-pista]'), minis = todos(g, '[data-gla-mini]'), pts = todos(g, '.gla-gal__pts i');
    var n = pista ? pista.children.length : 0, i = 0;
    function marcar(k) {
      i = k;
      minis.forEach(function (m, j) { m.classList.toggle('on', j === k); });
      pts.forEach(function (p, j) { p.classList.toggle('on', j === k); });
    }
    function ir(k) {
      if (!pista || !n) return;
      k = (k + n) % n;
      pista.scrollTo({ left: pista.clientWidth * k, behavior: 'smooth' });
      marcar(k);
    }
    minis.forEach(function (m, j) { m.addEventListener('click', function () { ir(j); }); });
    var a = g.querySelector('[data-gla-ant]'), s = g.querySelector('[data-gla-sig]');
    if (a) a.addEventListener('click', function () { ir(i - 1); });
    if (s) s.addEventListener('click', function () { ir(i + 1); });
    if (pista) pista.addEventListener('scroll', function () {
      var k = Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth));
      if (k !== i) marcar(k);
    }, { passive: true });
    var z = g.querySelector('[data-gla-zoom]'), modal = root.querySelector('[data-gla-modal]');
    if (z && modal && modal.showModal) {
      z.addEventListener('click', function () {
        var img = pista && pista.children[i] && pista.children[i].querySelector('img');
        if (!img) return;
        modal.querySelector('[data-gla-modal-img]').src = img.currentSrc || img.src;
        modal.showModal();
      });
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('[data-gla-cerrar-modal]')) modal.close(); });
    }
    var actual = pista && pista.querySelector('[data-gla-actual]');
    if (actual) {
      var k0 = Array.prototype.indexOf.call(pista.children, actual.parentNode);
      if (k0 > 0) { pista.scrollLeft = pista.clientWidth * k0; marcar(k0); }
    }
    return {
      porSrc: function (src) {
        if (!pista || !src) return;
        var base = src.split('?')[0].replace(/_\d+x\d*(?=\.)/, '');
        for (var k = 0; k < n; k++) {
          var im = pista.children[k].querySelector('img');
          if (im && im.src.split('?')[0].replace(/_\d+x\d*(?=\.)/, '') === base) { ir(k); return; }
        }
      }
    };
  }

  // ------------------------------------------------------------ ficha de producto
  function producto(root) {
    if (root.dataset.glaOk) return;
    root.dataset.glaOk = '1';
    var gal = galeria(root);
    var datos = {};
    try { datos = JSON.parse(root.querySelector('[data-gla-datos]').textContent); } catch (e) { datos = { variantes: [] }; }
    var vs = datos.variantes || [], formato = datos.formato;
    var idIn = root.querySelector('input[name="id"]'), cantIn = root.querySelector('[data-gla-cant-input]'), cta = root.querySelector('[data-gla-cta]');
    var actual = vs.filter(function (v) { return idIn && String(v.id) === idIn.value; })[0] || vs[0];
    var textoCta = cta ? cta.querySelector('[data-gla-cta-txt]').textContent : '';
    var cant = 1;

    function pintar() {
      if (!actual) return;
      todos(root, '[data-gla-precio]').forEach(function (x) { x.textContent = dinero(actual.precio, formato); });
      todos(root, '[data-gla-antes]').forEach(function (x) { x.textContent = dinero(actual.antes, formato); x.hidden = !(actual.antes > actual.precio); });
      if (cta) {
        cta.disabled = !actual.disponible;
        var t = cta.querySelector('[data-gla-cta-txt]');
        if (t) t.textContent = actual.disponible ? textoCta : (cta.dataset.agotado || t.textContent);
      }
    }
    function elegir(v) {
      actual = v;
      if (idIn) idIn.value = v.id;
      todos(root, '[data-gla-opcion]').forEach(function (o) {
        var i = Number(o.dataset.glaOpcion);
        todos(o, '[data-gla-valor-opc]').forEach(function (b) { b.classList.toggle('on', b.dataset.glaValorOpc === v.opciones[i]); });
        var lab = o.querySelector('[data-gla-valor]');
        if (lab) lab.textContent = v.opciones[i] || '';
      });
      if (gal && v.img) gal.porSrc(v.img);
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) { /* sin historial */ }
      pintar();
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: { id: v.id } } }));
    }
    todos(root, '[data-gla-opcion]').forEach(function (o) {
      var i = Number(o.dataset.glaOpcion);
      todos(o, '[data-gla-valor-opc]').forEach(function (b) {
        var hay = vs.some(function (v) { return v.opciones[i] === b.dataset.glaValorOpc && v.disponible; });
        if (!hay) b.classList.add('agotado');
        b.addEventListener('click', function () {
          var quiero = (actual ? actual.opciones : []).slice();
          quiero[i] = b.dataset.glaValorOpc;
          var v = vs.filter(function (x) { return x.opciones.every(function (val, k) { return val === quiero[k]; }); })[0]
            || vs.filter(function (x) { return x.opciones[i] === quiero[i] && x.disponible; })[0]
            || vs.filter(function (x) { return x.opciones[i] === quiero[i]; })[0];
          if (v) elegir(v);
        });
      });
    });
    var c = root.querySelector('[data-gla-cant]');
    function fijarCant(q) {
      cant = Math.max(1, Math.min(99, Number(q) || 1));
      if (c) c.value = cant;
      if (cantIn) cantIn.value = cant;
    }
    if (c) {
      c.addEventListener('change', function () { fijarCant(c.value); });
      var menos = root.querySelector('[data-gla-menos]'), mas = root.querySelector('[data-gla-mas]');
      if (menos) menos.addEventListener('click', function () { fijarCant(cant - 1); });
      if (mas) mas.addEventListener('click', function () { fijarCant(cant + 1); });
    }
    // barra fija en el móvil cuando el botón de compra no se ve
    var barra = root.querySelector('[data-gla-barra]');
    if (barra && cta && 'IntersectionObserver' in window) {
      var visto = false;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) visto = true;
          var on = visto && !e.isIntersecting && e.boundingClientRect.top < 0;
          barra.classList.toggle('on', on);
          barra.setAttribute('aria-hidden', on ? 'false' : 'true');
          var b = barra.querySelector('button');
          if (b) b.tabIndex = on ? 0 : -1;
        });
      }).observe(cta);
      barra.querySelector('[data-gla-barra-btn]').addEventListener('click', function () {
        cta.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    pintar();
  }

  // ------------------------------------------------------------ pestañas
  function pestanas(root) {
    if (root.dataset.glaOk) return;
    root.dataset.glaOk = '1';
    var tabs = todos(root, '[role=tab]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) {
          var on = x === t, p = document.getElementById(x.getAttribute('aria-controls'));
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          if (p) {
            p.hidden = !on;
            var d = p.querySelector('details');
            if (d && on) d.open = true;
          }
        });
      });
    });
    // en el móvil son desplegables: todas visibles
    var mq = window.matchMedia('(max-width: 989px)');
    function modo() { if (mq.matches) todos(root, '[role=tabpanel]').forEach(function (p) { p.hidden = false; }); }
    modo();
    if (mq.addEventListener) mq.addEventListener('change', function () { if (!mq.matches) { var t = root.querySelector('[role=tab][aria-selected=true]') || tabs[0]; if (t) t.click(); } else modo(); });
  }

  // ------------------------------------------------------------ pasos (carrusel con puntos en el móvil)
  function pasos(ol) {
    if (ol.dataset.glaOk) return;
    ol.dataset.glaOk = '1';
    var pts = todos(ol.parentNode, '.gla-pts i');
    ol.addEventListener('scroll', function () {
      var k = Math.round(ol.scrollLeft / Math.max(1, ol.clientWidth));
      pts.forEach(function (p, j) { p.classList.toggle('on', j === k); });
    }, { passive: true });
  }

  // ------------------------------------------------------------ reseñas de cinco en cinco
  function resenas(root) {
    if (root.dataset.glaOk) return;
    root.dataset.glaOk = '1';
    var rs = todos(root, '[data-gla-rev]'), nav = root.querySelector('[data-gla-pag]'), por = 5;
    var paginas = Math.ceil(rs.length / por);
    if (!nav || paginas < 2) return;
    function ver(p) {
      rs.forEach(function (r, i) { r.hidden = Math.floor(i / por) !== p; });
      todos(nav, 'button[data-p]').forEach(function (b) { b.classList.toggle('on', Number(b.dataset.p) === p); b.setAttribute('aria-current', Number(b.dataset.p) === p ? 'page' : 'false'); });
    }
    for (var p = 0; p < paginas; p++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.dataset.p = p;
      b.textContent = p + 1;
      b.addEventListener('click', function (e) { ver(Number(e.currentTarget.dataset.p)); root.scrollIntoView({ behavior: 'smooth' }); });
      nav.appendChild(b);
    }
    ver(0);
  }

  // ------------------------------------------------------------ menú del móvil
  function menu(root) {
    var b = root.querySelector('[data-gla-menu]'), m = b && document.getElementById(b.getAttribute('aria-controls'));
    if (!b || !m || b.dataset.glaOk) return;
    b.dataset.glaOk = '1';
    function cerrar() { m.hidden = true; b.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; b.focus(); }
    b.addEventListener('click', function () { m.hidden = false; b.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden'; var x = m.querySelector('[data-gla-cerrar]'); if (x) x.focus(); });
    m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('[data-gla-cerrar]')) cerrar(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) cerrar(); });
  }

  // ------------------------------------------------------------ recomendaciones de Shopify (sin productos elegidos)
  function recos(sec) {
    if (sec.dataset.glaOk) return;
    sec.dataset.glaOk = '1';
    fetch(sec.dataset.glaRecos).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!html) return;
      var d = document.createElement('div');
      d.innerHTML = html;
      var nueva = d.querySelector('.gla-rel');
      if (nueva && nueva.querySelector('.gla-card')) {
        sec.querySelector('.gla-rel__g').innerHTML = nueva.querySelector('.gla-rel__g').innerHTML;
        sec.hidden = false;
      }
    }).catch(function () { /* sin recomendaciones */ });
  }

  function iniciar() {
    todos(document, '[data-gla-producto]').forEach(producto);
    todos(document, '[data-gla-tabs]').forEach(pestanas);
    todos(document, '[data-gla-pasos]').forEach(pasos);
    todos(document, '[data-gla-resenas]').forEach(resenas);
    todos(document, '.gla-cab-s').forEach(menu);
    todos(document, '[data-gla-recos]').forEach(recos);
    // el pie, siempre al final (la app puede añadir secciones detrás)
    var pie = document.querySelector('[data-gla-pie]');
    var sec = pie && pie.closest('.shopify-section');
    if (sec && sec.parentNode && sec.parentNode.lastElementChild !== sec) sec.parentNode.appendChild(sec);
    // contador del carrito de la cabecera propia
    document.addEventListener('cart:updated', function (e) {
      var n = e.detail && e.detail.cart && e.detail.cart.item_count;
      if (n != null) todos(document, '[data-gla-n]').forEach(function (x) { x.textContent = n; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
